const QUEUED_WORKFLOW_RUN_ACTIVE_MS = 2 * 60 * 1000;
const ACTIVE_WORKFLOW_RUN_STATUSES = new Set(['running']);
const TERMINAL_WORKFLOW_RUN_STATUSES = new Set(['succeeded', 'failed', 'canceled', 'duplicate_prevented']);
const CANCELABLE_WORKFLOW_RUN_STATUSES = new Set(['queued', 'running']);

export const getWorkflowRunId = (run) => {
  return String(run?.id || '').trim();
};

const getWorkflowRunStatus = (run) => {
  return String(run?.status || '')
    .trim()
    .toLowerCase();
};

const getWorkflowRunQueuedAtMs = (run) => {
  const parsed = Date.parse(run?.meta?.queuedAt || run?.createdAt || '');

  return Number.isFinite(parsed) ? parsed : null;
};

export const isWorkflowRunActive = (run) => {
  const status = getWorkflowRunStatus(run);

  if (ACTIVE_WORKFLOW_RUN_STATUSES.has(status)) {
    return true;
  }

  if (status !== 'queued') {
    return false;
  }

  const queuedAtMs = getWorkflowRunQueuedAtMs(run);

  if (queuedAtMs === null) {
    return false;
  }

  return Date.now() - queuedAtMs < QUEUED_WORKFLOW_RUN_ACTIVE_MS;
};

export const isWorkflowRunTerminal = (run) => {
  return TERMINAL_WORKFLOW_RUN_STATUSES.has(getWorkflowRunStatus(run));
};

/* Not the same question as "active": the busy window above stops a run that has sat in the queue
   for minutes from holding the Run button, but a run still queued after that long is exactly the one
   someone wants to stop. The backend cancels any queued or running run, so this matches it. */
export const isWorkflowRunCancelable = (run) => {
  return CANCELABLE_WORKFLOW_RUN_STATUSES.has(getWorkflowRunStatus(run));
};
